import generateBlockId from '../../utils/generateBlockId';
import { OT_BLOCKS } from '../../../types/BlockTypes';

function filterInvalideNodes(node) {
  return OT_BLOCKS.includes(node.type) && !node.getIn(['data', 'id']);
}

export default function otBlocksShouldHaveIds(node, editor, next) {
  if (node.object !== 'document') return next();
  var nodesToNormalize = editor.value.document.filterDescendants(filterInvalideNodes);
  if (nodesToNormalize.isEmpty()) return next(); // This is the mapping Slate does internally for each *Key to *Path
  // methods. We do it once and memoized it. We'll use it later instead of
  // calling multiple time node.getPath, which in turn calls this.

  var keysToPathsTable = editor.value.document.getKeysToPathsTable();
  nodesToNormalize.forEach(function (child) {
    // Slate is storing a copy of the path internally in order to
    // re-normalize it after a complete pass of normalization. But by
    // doing so, it also reduce on the whole array of previously modified
    // path and tries to transform them, taking each loop a little bit
    // longer. As our normalization here does not change anything except
    // data, we save this value to force back it just after.
    var dirty = editor.controller.tmp.dirty;
    editor.applyOperation({
      type: 'set_node',
      path: keysToPathsTable[child.key],
      properties: {
        data: child.data
      },
      newProperties: {
        data: child.data.set('id', generateBlockId())
      }
    });
    editor.controller.tmp.dirty = dirty;
  });
  return next();
}